import React from "react";
import PodcastSingleCategoryPromote from "../../../components/OrPodcastSingleCategoryPromote";

const PodcastSingleCategoryPromoteWidget = props => (
  <PodcastSingleCategoryPromote {...props} />
);

export default PodcastSingleCategoryPromoteWidget;
